var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"broadcast-type-list"},_vm._l((_vm.uniqBroadcastTypes),function(broadcastType){return _c('broadcast-type-label',{key:broadcastType,staticClass:"broadcast-type",attrs:{"type":broadcastType}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }